import { ENGLISH, HEBREW } from "@lts-web/types/LocaleTypes";
import { replaceArray } from "@lts-web/utils/StringUtil";

const hebrewChars = [0x002F, 0x0027, 0x05E7, 0x05E8, 0x05D0, 0x05D8, 0x05D5, 0x05DF, 0x05DD, 0x05E4, 0x05E9, 0x05D3, 0x05D2, 0x05DB, 0x05E2, 0x05D9, 0x05D7, 0x05DC, 0x05DA, 0x05E3, 0x05D6, 0x05E1, 0x05D1, 0x05D4, 0x05E0, 0x05DE, 0x05E6, 0x05EA, 0x05E5];
const englishChars = ["q", "w", "e", "r", "t", "y", "u", "i", "o", "p", "a", "s", "d", "f", "g", "h", "j", "k", "l", ";", "z", "x", "c", "v", "b", "n", "m", ",", "."];

class KeyboardLayoutUtil {
    static layouts = new Map();

    static init () {
        KeyboardLayoutUtil.layouts.set(ENGLISH, englishChars);
        KeyboardLayoutUtil.layouts.set(HEBREW, String.fromCharCode(...hebrewChars).split(''));
    }

    static convertLayout (prefix, fromLocale = ENGLISH, toLocale = HEBREW) {
        const fromLayout = KeyboardLayoutUtil.getLayout(fromLocale);
        const toLayout = KeyboardLayoutUtil.getLayout(toLocale);

        return replaceArray(prefix, fromLayout, toLayout);
    }

    static getLayout (key) {
        return KeyboardLayoutUtil.layouts.get(key);
    }
}

KeyboardLayoutUtil.init();

export default KeyboardLayoutUtil;